import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const ListIcon: React.FC<Props> = () => {
  return (
    <SVGIcon width="20" height="20" viewBox="0 0 20 20">
      <g>
        <path
          d="M5.96006 4.31543C4.82947 4.31543 3.90088 5.24402 3.90088 6.37461V17.6065C3.90088 18.7371 4.82947 19.6657 5.96006 19.6657H17.9408C19.0714 19.6657 20 18.7371 20 17.6065V6.37461C20 5.24402 19.0714 4.31543 17.9408 4.31543H5.96006ZM5.02407 7.68501H18.8768V17.6065C18.8768 18.13 18.4643 18.5425 17.9408 18.5425H5.96006C5.43657 18.5425 5.02407 18.13 5.02407 17.6065V7.68501Z"
          fill="#252425"
        />
        <path
          d="M16.6667 3.48647C16.3253 2.82079 15.6332 2.36328 14.835 2.36328H3.97746C2.84191 2.36328 1.91827 3.28692 1.91827 4.42247V16.4032C1.91827 17.2014 2.37578 17.8935 3.04146 18.235V5.54566C3.04146 4.42247 3.97746 3.48647 5.10065 3.48647H16.6667Z"
          fill="#252425"
        />
        <path
          d="M14.7485 1.45718C14.407 0.791498 13.7149 0.333984 12.9167 0.333984H2.05918C0.923635 0.333984 -3.8147e-06 1.25762 -3.8147e-06 2.39317V14.3739C-3.8147e-06 15.1721 0.45751 15.8642 1.12319 16.2057V3.51636C1.12319 2.39317 2.05918 1.45718 3.18237 1.45718H14.7485Z"
          fill="#252425"
        />
        <path
          d="M6.5217 10.048H9.1304C9.3704 10.048 9.56519 9.74498 9.56519 9.37164C9.56519 8.99831 9.3704 8.69531 9.1304 8.69531H6.5217C6.2817 8.69531 6.08691 8.99831 6.08691 9.37164C6.08691 9.74498 6.2817 10.048 6.5217 10.048Z"
          fill="#252425"
        />
        <path
          d="M10.5797 10.048H13.1884C13.4284 10.048 13.6232 9.74498 13.6232 9.37164C13.6232 8.99831 13.4284 8.69531 13.1884 8.69531H10.5797C10.3397 8.69531 10.145 8.99831 10.145 9.37164C10.145 9.74498 10.3397 10.048 10.5797 10.048Z"
          fill="#252425"
        />
        <path
          d="M15.6522 12.0763H6.95648C6.47648 12.0763 6.08691 11.7733 6.08691 11.4C6.08691 11.0266 6.47648 10.7236 6.95648 10.7236H15.6522C16.1322 10.7236 16.5217 11.0266 16.5217 11.4C16.5217 11.7733 16.1322 12.0763 15.6522 12.0763Z"
          fill="#252425"
        />
        <path
          d="M9.80673 17.2941H6.42508C6.23841 17.2941 6.08691 16.9911 6.08691 16.6177C6.08691 16.2444 6.23841 15.9414 6.42508 15.9414H9.80673C9.9934 15.9414 10.1449 16.2444 10.1449 16.6177C10.1449 16.9911 9.9934 17.2941 9.80673 17.2941Z"
          fill="#252425"
        />
      </g>
    </SVGIcon>
  );
};

export default ListIcon;
